import { z } from 'zod';
/**
 * Zod is the source of truth for request/response validation and for the
 * inferred TypeScript types the API client consumes (00 §7.6). Iteration 02
 * only needs the healthz response contract; domain schemas land from 03.
 */
export const healthResponseSchema = z.object({
    status: z.literal('ok'),
    version: z.string().min(1),
});
//# sourceMappingURL=health.js.map